<ng-container *transloco="let t">
  <section class="register-form">
    <div class="register-form-container">
      <h1 class="h1">{{ t('general.title') }}</h1>
      <app-steper></app-steper>
      <div id="msform">
        <router-outlet></router-outlet>
      </div>
    </div>
  </section>
</ng-container>
